import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './state'
import { reducers } from './reducers'

export const footprintSlice = createSlice({
  name: 'users',
  initialState,
  reducers
})

// Show Types
export const { setFootPrintTypesLoading } = footprintSlice.actions
export const { setFootPrintTypesResponse } = footprintSlice.actions
export const { setFootPrintTypesError } = footprintSlice.actions

// Get All
export const { setFootPrintLoading } = footprintSlice.actions
export const { setFootPrintResponse } = footprintSlice.actions
export const { setFootPrintError } = footprintSlice.actions

// Create
export const { setCreateFootPrintLoading } = footprintSlice.actions
export const { setCreateFootPrintSuccess } = footprintSlice.actions
export const { setCreateFootPrintError } = footprintSlice.actions
export const { addFootPrintToList } = footprintSlice.actions
export const { resetFootPrintCreateState } = footprintSlice.actions

// Update
export const { setUpdateFootPrintLoading } = footprintSlice.actions
export const { setUpdateFootPrintSuccess } = footprintSlice.actions
export const { setUpdateFootPrintError } = footprintSlice.actions
export const { updateFootPrintList } = footprintSlice.actions
export const { resetUpdateFootPrintState } = footprintSlice.actions

// Show Types
export const { setDeleteFootPrintSuccess } = footprintSlice.actions
export const { setDeleteFootPrintLoading } = footprintSlice.actions
export const { deleteFootPrintItemFromList } = footprintSlice.actions

// FootPrint VS Compensation Reducers
export const { setFootPrintVsCompensationLoading } = footprintSlice.actions
export const { setFootPrintVsCompensationData } = footprintSlice.actions

// FootPrint History Reducers
export const { setFootPrintHistoryLoading } = footprintSlice.actions
export const { setFootPrintHistoryData } = footprintSlice.actions

export default footprintSlice.reducer
